
import axios from "axios";
import moment from 'moment'
import Tools from '@/tools/tools.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      id: null,
      pedido: null,
      clienteId: null,
      tipoSituacao: null,
      filtrou: false
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    PEDIDO: state => {
        return state.pedido
    },
    TIPO_SITUACAO: state => {
        return state.tipoSituacao
    },
    FILTROU: state => {
        return state.filtrou
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CLIENTE_ID: (state, payload) => {
          state.clienteId = payload
      },
      SET_PEDIDO: (state, payload) => {
          state.pedido = payload
      },
      SET_TIPO_SITUACAO: (state, payload) => {
          state.tipoSituacao = payload
      },
      SET_FILTROU: (state, payload) => {
          state.filtrou = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.id = null
        state.pedido = null
        state.clienteId = null
        state.tipoSituacao = ''
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}) => {
        return new Promise((resolve, reject) => {
          let id = (getters.ID !== null ? getters.ID : '')
          let clienteId = (getters.CLIENTE_ID !== null ? getters.CLIENTE_ID : '')
          let pedido = (getters.PEDIDO !== null ? getters.PEDIDO : '')
          let tipoSituacao = (getters.TIPO_SITUACAO !== null ? getters.TIPO_SITUACAO : '')
          let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
          let dt2 = (getters.DT2 !== null ? getters.DT2 : '')

          let uri = `/api/protected/vendapedido/pesquisar?vendedorId=${window.localStorage.getItem('vendedorId')}&id=${id}&dt1=${dt1}`+
                    `&dt2=${dt2}&pedido=${pedido}`
           if (tipoSituacao) {            
            uri += `&situacao=${tipoSituacao}`
           } 
           if (clienteId) {
            uri += `&clienteId=${clienteId}`
           }
          axios
            .get(uri)
            .then(({ data, status }) => {
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {

                //ajustar a lista de pesquisa com as maskaras
                for (let i = 0; i < data.length; i++) {
                    if (!!data[i].PERCENTUAL) {
                        data[i].PERCENTUAL   = data[i].PERCENTUAL.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 2})
                    } else {
                        data[i].PERCENTUAL = 0.00
                    }
                    if (!!data[i].DT_PEDIDO) {
                        data[i].DT_PEDIDO     = Tools.formatarDataBR(data[i].DT_PEDIDO)
                    }
                    if (!!data[i].DT_SAIDA) {
                        data[i].DT_SAIDA     = Tools.formatarDataParaInput(data[i].DT_SAIDA)
                    }
                    if (!!data[i].VENCIMENTO) {
                    data[i].VENCIMENTO = Tools.formatarDataParaInput(data[i].VENCIMENTO)
                    } else {
                    data[i].VENCIMENTO = null
                    }
                }
                
                resolve({ data, status });
              }
            })
            .catch(error => {
              reject(error)
            })
        })
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/venda-pedido-store.js